import { IShadowRepresentativeCreate } from '../interfaces/shadowRepresentativeCreate';
import { AnagraphicType } from '../enums/anagraphicType.enum';

export class ShadowRepresentativeCreate implements IShadowRepresentativeCreate {
    address: string;
    anagraphicType: AnagraphicType;
    city: string;
    email: string;
    exponentAddress: string;
    faxNumber: string;
    firstName: string;
    fiscalCode: string;
    id: number;
    lastName: string;
    mobilePhoneNumber: string;
    note: string;
    numberAddress: string;
    phoneNumber: string;
    postalCode: string;
    province: string;
    shortProvince: string;
    constructor(ga?: IShadowRepresentativeCreate) {
        if (ga) {
            this.address = ga.address;
            this.anagraphicType = ga.anagraphicType;
            this.city = ga.city;
            this.email = ga.email;
            this.exponentAddress = ga.exponentAddress;
            this.faxNumber = ga.faxNumber;
            this.firstName = ga.firstName;
            this.fiscalCode = ga.fiscalCode;
            this.id = ga.id;
            this.lastName = ga.lastName;
            this.mobilePhoneNumber = ga.mobilePhoneNumber;
            this.note = ga.note;
            this.numberAddress = ga.numberAddress;
            this.phoneNumber = ga.phoneNumber;
            this.postalCode = ga.postalCode;
            this.province = ga.province;
            this.shortProvince = ga.shortProvince;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/shadowRepresentativeCreate.ts